var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check-box"},[_c('custom-checkbox',{attrs:{"color":"cold-marine","value":_vm.value,"size":"s"},on:{"input":function($event){_vm.value = !_vm.value}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }